import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DateConfig } from '@core/config/global.config';
import { TranslateService } from '@ngx-translate/core';
import { OptionalValuePipe } from './option-value.pipe';

@Pipe({
  name: 'localizedDate',
  pure: true,
  standalone: true,
})
export class LocalizedDatePipe implements PipeTransform {
  private datePipe = inject(DatePipe);
  private translateService = inject(TranslateService);
  private optionalValuePipe = inject(OptionalValuePipe);

  transform(value: any, utc: boolean = true): string | null {
    if (this.isNullOrEmpty(value)) {
      return this.optionalValuePipe.transform(value);
    }

    const currentLang = this.translateService.currentLang ?? 'it';
    // ! - do not delete!!!
    // const format = currentLang === 'it' ? DateConfig.it : DateConfig.en;

    const date = this.normalizeDate(value, utc);

    return this.datePipe.transform(date, undefined, undefined, currentLang)?.toUpperCase() ?? null;
  }

  private normalizeDate(value: any, utc?: boolean): Date | number {
    let date: Date;

    if (value instanceof Date) {
      date = value;
    } else if (typeof value === 'string' && value.endsWith('Z')) {
      date = new Date(value);
    } else if (typeof value === 'number') {
      date = new Date(value);
    } else {
      date = new Date(value);
    }

    return utc ? this.toUTC(date) : date;
  }

  private toUTC(date: Date): Date {
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds(),
    ));
  }

  private isNullOrEmpty(val: any): boolean {
    return val === null || val === '' || val === undefined;
  }
}
